<template>
  <div>
    <van-cell title="电子卡" label="可用积分:1600" value="切换油卡" is-link to="#"/>
    <div style="padding:10px;background:#fff;margin-top:10px">
      <van-image width="120" height="115"  src="https://maximum_api.bei-lin.cn/wechat_oa/weida.png" />
        <van-row style="width: calc(100% - 140px); float: right;">
        <van-col span="18">维达抽纸超韧3层M码120抽24包整箱装</van-col>
        <van-col span="16" style="margin-top:10px"><span class="by_jf">{{JF}}积分</span><span class="price">￥{{money}}</span></van-col>
      </van-row>
    </div>
    <div class="check">
      <div>选择数量</div>
        <div style="display: flex;margin-top:10px;line-height:30px">
          <van-stepper v-model="value" min="1" max="2" />
          <span style="font-size:14px;color:#666;margin-left:10px;">每人限购2件</span>
        </div>
    </div>
  <!-- 底部 -->
  <div class="foot">
    <van-submit-bar button-text="立即换购" currency="" decimal-length=""  >
      <template #default>
        <span style="font-size:16px;color:#e03997"> 合计 ：600积分</span>
        <span style="margin:0 10px;color:#0081ff">￥{{money*value}}</span>
      </template>
    </van-submit-bar>
  </div>
  </div>
</template>
<style lang="scss" scoped>
   .van-cell__value {
     line-height: 40px;
   }
   .van-cell__title span {
    display: inline-block;
    padding: 0 10px;
    background-color: #fbbd08;
    color:#fff
}

   .van-icon-arrow::before {
    position: relative;
    top: 8px;
  }

    .by_name {
      color: #666;
      margin-bottom: 15px;;
    }

    .by_jf {
      color:#e03997;
      margin-right: 10px;
    }

      .price {
        color:#0081ff;
      }
    .check {
      height: 70px;
      padding: 15px;
      background: #fff;
      margin-top: 10px;
    }

    .foot {
      width: 100%;
      height: 50px;
      position: fixed;
      bottom: 0;
      font-size: 14px;
    }
    .van-submit-bar__bar {
      padding: 0;

    .van-button--round {
        height:50px;
        border-radius: 0px;
    }
  }
</style>
<script>
export default {
  data () {
    return {
      money: 50,
      val: 1,
      JF: 600,
      value: 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/mall_buy.vue